import { useState } from "react";
import { cn } from "@/lib/utils";

interface TabsViewProps {
    id: string;
    data: any;
    renderElement: (element: any) => React.ReactNode;
}

export const TabsView = ({
    id,
    data,
    renderElement,
}: TabsViewProps) => {
    const [activeTab, setActiveTab] = useState(0);
    const tabs = data.tabs || [];

    return (
        <div
            className="w-full"
            style={{
                padding: `${data.padding || 20}px`,
                backgroundColor: data.backgroundColor || "#ffffff",
                borderRadius: `${data.borderRadius || 8}px`,
            }}
        >
            {/* Tabs Header */}
            <div className="flex flex-wrap gap-2 mb-4 border-b">
                {tabs.map((tab: any, index: number) => (
                    <button
                        key={tab.id || index}
                        onClick={() => setActiveTab(index)}
                        className={cn(
                            "px-4 py-2 text-sm font-medium transition-colors rounded-t-lg",
                            activeTab === index
                                ? "border-b-2"
                                : "hover:bg-gray-50"
                        )}
                        style={{
                            backgroundColor: activeTab === index ? data.activeTabColor : data.inactiveTabColor,
                            color: activeTab === index ? data.activeTextColor : data.inactiveTextColor,
                            borderColor: activeTab === index ? data.activeTabColor : "transparent",
                        }}
                    >
                        {tab.title}
                    </button>
                ))}
            </div>

            {/* Tabs Content */}
            <div className="min-h-[50px]">
                {tabs.map((tab: any, index: number) => (
                    <div
                        key={tab.id || index}
                        className={cn(
                            "w-full",
                            activeTab === index ? "block" : "hidden"
                        )}
                    >
                        {tab.elements && tab.elements.length > 0 ? (
                            tab.elements.map((element: any) => (
                                <div key={element.id} className="mb-4 last:mb-0">
                                    {renderElement(element)}
                                </div>
                            ))
                        ) : null}
                    </div>
                ))}
            </div>
        </div>
    );
};
